export default "__VITE_ASSET__wWlBqkCw__"